import React, { useState, useContext } from 'react';
import PropTypes from 'prop-types';
import { Icon } from 'uxd-design-system-components';
import getText from '../../assets/locale/locale';
import { LocaleContext } from '../../contexts';
import './ConnectFA.scss';
import addDataLayerTrigger from '../../utils/addDataLayerTrigger/addDataLayerTrigger';

const ConnectFA = ({ showCaFindFa }) => {
  const locId = useContext(LocaleContext);
  const searchURL = getText(locId, 'Results', 'url', 'ConnectFA');
  const placeholderText = getText(
    locId,
    'Results',
    'searchInitialValue',
    'ConnectFA'
  );
  const [searchValue, setSearchValue] = useState(placeholderText);

  const inputOnFocus = e => {
    if (e.target.value === placeholderText) {
      e.target.value = '';
    }
  };

  const inputOnBlur = e => {
    if (e.target.value === '') {
      e.target.value = placeholderText;
    }
  };

  const submitSearch = () => {
    if (searchValue !== '' && searchValue !== placeholderText) {
      addDataLayerTrigger('find-fa-click', {
        'find-fa-search-query': searchValue,
      });
      const win = window.open(`${searchURL}${searchValue}`, '_blank');
      win.focus();
    }
  };

  return (
    <div className="findFA__wrapper" data-testid="find-fa-search">
      <div className={showCaFindFa ? 'findFA findFA--canada' : 'findFA'}>
        <div className="findFA__content">
          <h2 className="findFA__header">
            {getText(locId, 'Results', 'header', 'ConnectFA')}
          </h2>
          {!showCaFindFa && (
            <>
              <div className="findFA_connect-container">
                <p>
                  {getText(locId, 'Results', 'connectBtnLabel', 'ConnectFA')}
                </p>
                <a
                  href={getText(
                    locId,
                    'Results',
                    'connectLinkURL',
                    'ConnectFA'
                  )}
                  className="button findFA__btn"
                  rel="noopener noreferrer"
                  target="_blank"
                  onClick={() => addDataLayerTrigger('ej-match-click')}
                >
                  {getText(locId, 'Results', 'connectLinkText', 'ConnectFA')}
                </a>
              </div>
              <p className="findFA__separator">
                {getText(locId, 'Results', 'separatorText', 'ConnectFA')}
              </p>
            </>
          )}
          <div className="findFA__search-container input-control">
            <label htmlFor="searchFA" className="input-text">
              {getText(locId, 'Results', 'searchLabel', 'ConnectFA')}
            </label>
            <div className="input-control--input--wrap findFA__input">
              <input
                type="text"
                name="searchFA"
                id="searchFA"
                data-testid="find-fa-search-input"
                value={searchValue}
                onChange={e => setSearchValue(e.target.value)}
                onFocus={inputOnFocus}
                onBlur={inputOnBlur}
              />
              <div
                className="search-icon"
                onClick={submitSearch}
                tabIndex="0"
                onKeyPress={submitSearch}
                role="button"
              >
                <Icon name="search" />
              </div>
            </div>
            <button
              type="submit"
              className="button findFA__btn findFA__btn--search"
              data-testid="find-fa-search-submit"
              onClick={submitSearch}
            >
              {getText(locId, 'Results', 'searchSubmitButton', 'ConnectFA')}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

ConnectFA.propTypes = {
  showCaFindFa: PropTypes.bool,
};

ConnectFA.defaultProps = {
  showCaFindFa: false,
};

export default ConnectFA;
